<script setup lang="ts">
import { ref } from 'vue'
import FosInput from '@/components/ui/FosInput.vue'
import FosButton from '@/components/ui/FosButton.vue'

const emit = defineEmits<{ unlocked: [] }>()

const password = ref('')
const error = ref(false)

function submit() {
  if (password.value === import.meta.env.VITE_BETA_PASSWORD) {
    localStorage.setItem('beta_unlocked', 'true')
    emit('unlocked')
  } else {
    error.value = true
    password.value = ''
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="w-full max-w-sm">
      <div class="bg-surface border border-border rounded-lg p-8 flex flex-col gap-6">
        <div class="flex flex-col gap-1">
          <p class="font-mono text-[0.6rem] uppercase tracking-widest text-outline">Alpha Access</p>
          <h1 class="font-display text-xl font-bold text-on-surface uppercase tracking-tight">First on Scene</h1>
          <p class="font-mono text-xs text-on-surface-variant mt-1">Enter the alpha access code to continue.</p>
        </div>

        <form class="flex flex-col gap-3" @submit.prevent="submit">
          <div class="flex flex-col gap-1.5">
            <FosInput
              v-model="password"
              type="password"
              placeholder="Access code"
              @input="error = false"
            />
            <p v-if="error" class="font-mono text-[0.65rem] text-error">Incorrect access code. Try again.</p>
          </div>
          <FosButton type="submit" variant="primary" size="lg" class="w-full">
            Unlock
          </FosButton>
        </form>
      </div>
    </div>
  </div>
</template>
